// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__bG4kX","mainMessage":"ErrorPage_mainMessage__dw2dA","subMessageArea":"ErrorPage_subMessageArea__rF7do","buttonArea":"ErrorPage_buttonArea__IqFVp"};